
<ul class="bread__menu-list">
  <li (click)="goToUrl('item')" style="font-size: 11px;">
    <ng-container *ngFor="let item of breadcrumbs;  let indexOfElement = index" >
      <a *ngIf="indexOfElement > 0" (click)="goToUrl(item)"  [ngClass]="getClass(item)"
        >{{item | firstLetterUppercase}} <span class="pipe" *ngIf="indexOfElement !== breadcrumbs.length - 1"> > </span> </a> 
    </ng-container>
  </li>
</ul>